import * as React from "react";

import { AirportMapPlace } from "stores/FlightsStore";
import { EGMapDisplayCard } from "../components/EGMapDisplayCard";
import MapFlightSheet from "components/flexComponents/Maps/components/MapFlightSheet";
import MapPoiSheet from "components/flexComponents/Maps/components/MapPoiSheet";
import { PoiForMap } from "components/flexComponents/Maps/typings";
import { UitkMapPlaceCardProps } from "../typings";

type MapPropertyAndCardProps = UitkMapPlaceCardProps & {
  isMobile: boolean | undefined;
  href: string | undefined;
  componentName: string;
};

export const MapDisplayCard = (props: MapPropertyAndCardProps) => {
  const { componentName, place, isMobile, isVisible, href } = props;
  if (!place) {
    return null;
  }
  const iconType = place.icon && place.icon.type;
  switch (iconType) {
    case "price":
    case "soldOut":
      return <EGMapDisplayCard componentName={componentName} place={place} isVisible={isVisible} href={href} />;
    case "airport":
      const flight = place as AirportMapPlace;

      return (
        <MapFlightSheet flight={flight.flight} index={flight.id as number} isVisible={isVisible} isMobile={isMobile} />
      );

    default:
      return (
        <MapPoiSheet
          id={(place as PoiForMap).id}
          title={(place as PoiForMap).name}
          photoUrl={(place as PoiForMap).imageUrl}
          description={(place as PoiForMap).description}
          isVisible={isVisible}
        />
      );
  }
};

export default MapDisplayCard;
